import React from 'react';
import { ComponentProps, inject, deps, observer } from '../../../lib/component';
import { style } from 'typestyle';
import { MusicLayout } from '../templates/MusicLayout';
import { Loading } from '../../loading/loading';
import { ReleaseSidebar } from '../organisms/ReleaseSidebar';
import { px } from 'csx';
import { rebrand } from '../../../theme/color';
import { defaultHeadingStyles } from '../utilities/font';
import { isEmpty } from '../utilities/objects';
import { Link } from '../atoms/Link';
import { Release } from '../../release';
import { mediaDesktop } from '../utilities/mediaQueries';
import { spacing } from '../../../theme/spacing';

interface ReleasePageProps extends ComponentProps {}

const styles = {
  loading: style({
    margin: '25vh 0',
  }),
  masthead: style({
    textAlign: 'center',
  }),
  title: style({
    margin: 0,
  }),
  artistName: style(
    defaultHeadingStyles,
    {
      fontSize: px(24),
      margin: `${spacing.XXSMALL} 0 0`,
      color: rebrand.contrast[30].toString(),
      $nest: {
        '& a': {
          color: rebrand.contrast[30].toString(),
        },
        '& a:hover': {
          textDecoration: 'underline',
        },
      },
    },
    mediaDesktop({
      marginTop: spacing.XSMALL,
    })
  ),
};

export const ReleasePage: React.FC<ReleasePageProps> = inject(deps)(
  observer(
    ({
      model: {
        page: {
          release: { loading, selectedRelease, artist, artistSlug, otherReleases, releaseModels },
        },
      },
      controller: {
        ui: { handleClickLink },
      },
    }) => {
      if (loading) {
        return <Loading className={styles.loading} />;
      }

      const MastheadContent = (
        <div className={styles.masthead}>
          {selectedRelease && <h1 className={styles.title}>{selectedRelease.title}</h1>}
          {!isEmpty(artist) && (
            <p className={styles.artistName}>
              <Link href={`/music/artists/${artistSlug}`}>{artist.name}</Link>
            </p>
          )}
        </div>
      );
      const MainContent = <Release model={releaseModels[selectedRelease.identity]} onClickLink={handleClickLink} />;
      const SidebarContent = <ReleaseSidebar release={selectedRelease} artist={artist} otherReleases={otherReleases} />;

      return (
        <MusicLayout mastheadContent={MastheadContent} mainContent={MainContent} sidebarContent={SidebarContent} />
      );
    }
  )
);
